{
  "sampling": {
    "title": "Sampling",
    "evenDistribution": "Even (square) distribution",
    "evenDistributionDescription": "Spread the batch evenly across buckets of one filtered field.",
    "bucketField": "Bucket field",
    "bucketFieldPlaceholder": "Select a field",
    "bucketSize": "Bucket increment",
    "min": "Min",
    "max": "Max",
    "shuffle": "Shuffle presentation order",
    "shuffleDescription": "Records are presented to each labeller in a randomised order.",
    "perBucketNote": "≈{{quota}} per bucket across {{buckets}} buckets",
    "rangeError": "Min must be below max"
  },
  "filters": {
    "title": "Filters",
    "field": "Field",
    "fieldPlaceholder": "Select field",
    "incomplete": "Select a field and both bounds, or clear the row",
    "add": "+ Add filter",
    "remove": "Remove filter"
  },
  "bucketCoverage": {
    "title": "Bucket coverage",
    "target": "Target",
    "included": "Included",
    "available": "Available",
    "bucketTooltip": "{{included}} of {{target}} included ({{available}} available)"
  },
  "common": {
    "name": "Name",
    "description": "Description",
    "status": "Status",
    "customer": "Customer",
    "project": "Project",
    "projects": "Projects",
    "targetSize": "Target Size",
    "createProject": "Create Project",
    "editProject": "Edit Project",
    "createBatch": "Create Batch",
    "createRound": "Create Round",
    "save": "Save",
    "min": "Min",
    "max": "Max",
    "yes": "Yes",
    "no": "No",
    "noImage": "No image"
  },
  "projectsList": {
    "statusActive": "Active",
    "statusDraft": "Draft"
  },
  "projectDashboard": {
    "titleFallback": "Project Dashboard",
    "noRounds": "No rounds",
    "roundSummary": "{{roundName}}: {{complete}}/{{total}} complete",
    "roundsColumn": "Rounds",
    "createdColumn": "Created",
    "actionsColumn": "Actions",
    "batchesTitle": "Batches"
  },
  "projectSetup": {
    "newProject": "New Project",
    "editBreadcrumb": "Edit",
    "projectNameLabel": "Project Name",
    "projectNamePlaceholder": "Enter project name",
    "descriptionPlaceholder": "Enter project description",
    "customerPlaceholder": "Select customer",
    "dataSourceTypeLabel": "Data Source Type",
    "dataSourceTypePlaceholder": "Select data source type",
    "schemaLockedTitle": "Schema Locked",
    "schemaLockedMessage": "Label schema is locked and cannot be modified.",
    "projectNameRequired": "Project Name is required",
    "customerRequired": "Customer is required"
  },
  "schemaBuilder": {
    "title": "Label Schema",
    "noFieldsDefined": "No fields defined.",
    "noFieldsYet": "No fields added yet. Click \"Add Field\" to define your label schema.",
    "addField": "Add Field",
    "fieldKeyLabel": "Field Key",
    "fieldKeyPlaceholder": "Enter field key",
    "fieldLabelLabel": "Field Label",
    "fieldLabelPlaceholder": "Enter field label",
    "typeLabel": "Type",
    "typeText": "Text",
    "typeNumeric": "Numeric",
    "typeSingleSelect": "Single Select",
    "typeMultiSelect": "Multi Select",
    "typeBoolean": "Boolean",
    "requiredLabel": "Required",
    "minimumPlaceholder": "Minimum",
    "maximumPlaceholder": "Maximum",
    "stepLabel": "Step",
    "stepPlaceholder": "Step",
    "addOptionPlaceholder": "Add option"
  },
  "batchCuration": {
    "invalidRoute": "Invalid route: missing project or batch ID",
    "batchFallback": "Batch",
    "titleFallback": "Batch Curation",
    "finaliseButton": "Finalise Batch",
    "finaliseConfirm": "Are you sure you want to finalise this batch? This action cannot be undone.",
    "includedWord": "included",
    "excludedWord": "excluded",
    "totalWord": "total",
    "trimNote": "{{count}} extra will be trimmed on finalise",
    "shortNote": "{{count}} short of target",
    "batchConfigTitle": "Batch Config",
    "refetchButton": "Refetch"
  },
  "imageResults": {
    "title": "Image Results",
    "viewAllImages": "View all images",
    "included": "Included",
    "excluded": "Excluded",
    "includeButton": "Include",
    "excludeButton": "Exclude"
  },
  "allImages": {
    "title": "All Images",
    "imagesCount": "{{count}} images",
    "removeSelected": "Remove Selected ({{count}})"
  },
  "batchCreation": {
    "batchNameLabel": "Batch Name",
    "batchNamePlaceholder": "Enter batch name",
    "descriptionPlaceholder": "Enter batch description",
    "targetSizePlaceholder": "Enter target size",
    "extractButton": "Extract",
    "batchNameRequired": "Batch name is required",
    "targetSizeRequired": "Target size is required",
    "targetSizeMin": "Target size must be at least 1"
  },
  "createRound": {
    "roundNameLabel": "Round Name",
    "roundNamePlaceholder": "Enter round name",
    "roundNameRequired": "Round name is required",
    "assigneesLabel": "Assignees",
    "assigneesPlaceholder": "Select assignees"
  },
  "dataSourceParams": {
    "enterPlaceholder": "Enter {{label}}",
    "selectPlaceholder": "Select {{label}}",
    "uploadCsv": "Upload CSV",
    "changeFile": "Change file",
    "selectOrgFirst": "Select organisation first"
  },
  "labelling": {
    "assignmentNotFound": "Assignment not found",
    "noRecords": "No records to label",
    "noRecordSelected": "No record selected",
    "completeBadge": "Complete",
    "submit": "Submit assignment",
    "next": "Next",
    "recordsHeader": "Records",
    "labelledProgress": "Labelled {{labelled}} of {{total}}",
    "noImageAvailable": "No image available",
    "unsupportedFieldType": "Unsupported field type for \"{{label}}\""
  }
}
